import {
  Icon123,
  IconAlphabetLatin,
  IconAt,
  IconBuilding,
  IconCalendar,
  IconCheckbox,
  IconColumns,
  IconPilcrow,
  IconSelect,
  IconSignature,
  IconUser,
} from '@tabler/icons-react'
import { FieldType, FontFamily } from 'database'
import React, { forwardRef, useCallback, useMemo } from 'react'
import { cn } from 'ui'
import { documentFonts } from '../../../constants/fonts'
import { usePDFStore } from '../../../stores/pdf.store'

export const fieldItemDefaultDimensions = {
  width: 150,
  height: 48,
}

export const iconsFieldType: {
  [K in FieldType]: React.ComponentType<any>
} = {
  textarea: IconColumns,
  signature: IconSignature,
  checkbox: IconCheckbox,
  company_name: IconBuilding,
  initials: IconAlphabetLatin,
  number: Icon123,
  select: IconSelect,
  text: IconPilcrow,
  signature_date: IconCalendar,
  email: IconAt,
  person_name: IconUser,
}

export const FieldItemIcon = ({
  type,
  className,
}: {
  type: FieldType
  className?: string
}) => {
  const Icon = iconsFieldType[type]

  return <Icon className={cn('w-4 h-4 flex-shrink-0', className)} />
}

export const FieldItemLabel = ({
  children,
  className,
  style,
}: {
  children: React.ReactNode
  className?: string
  style?: React.CSSProperties
}) => {
  return (
    <span
      style={style}
      className={cn(
        'flex flex-row items-center justify-center [&>svg]:mr-1 line-clamp-2 truncate w-full',
        className
      )}
    >
      {children}
    </span>
  )
}

export const FieldItem = forwardRef<
  HTMLDivElement,
  React.HTMLProps<HTMLDivElement> & {
    fontFamily: FontFamily
    fontSize: number
    fontColor: string
  }
>(({ className, style, fontFamily, fontSize, fontColor, ...props }, ref) => {
  const pointsToPixels = useCallback((points: number) => (points / 72) * 96, [])

  const zoom = usePDFStore((state) => state.zoom)

  const adjustedFontSize = useMemo(
    () => pointsToPixels(fontSize) * zoom,
    [zoom, fontSize]
  )

  console.log(
    'font size',
    fontSize,
    'adjustedFontSize',
    adjustedFontSize,
    'zoom',
    zoom,
    'field'
  )

  return (
    <div
      {...props}
      style={{
        color: fontColor,
        width: fieldItemDefaultDimensions.width,
        height: fieldItemDefaultDimensions.height,
        fontSize: `${adjustedFontSize}px`,
        ...style,
      }}
      className={cn(
        'opacity-80 flex items-center justify-center h-full flex-col p-1 space-y-1',
        className,
        documentFonts[fontFamily].className
      )}
      ref={ref}
    />
  )
})
